<template>
    <!-- 매입매출 이력 조회 -->
    <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
            <h2 class="accordion-header">
                <ElButton 
                    type="accordionHeader" 
                    target="panelsStayOpen-collapse-inoutHistory"
                >
                    매입매출 이력
                </ElButton>
            </h2>
            <div id="panelsStayOpen-collapse-inoutHistory" class="accordion-collapse collapse">
                <div class="accordion-body accordion-body-register">
                    <!-- 엑셀 다운 -->
                    <div class="d-flex justify-content-between">
                        <div></div>
                        <div class="table-btn-group d-flex align-items-center">
                            <ElButton type="excelDownload" @buttonClick="inoutHistExcelDown()">엑셀다운</ElButton>
                        </div>
                    </div>

                    <!-- 테이블 리스트 -->
                    <div class="table-list">
                        <DataTable
                            :value="inoutHistDataList.searchedInoutHistList"
                            paginator
                            removableSort
                            :rows="rowsPerPage"
                            :rowsPerPageOptions="[10, 20, 50, 100, 200]"
                            @page="(event) => (currentPage = event.page)"
                            :pt="{
                                wrapper : {style:'height : 600px'},
                                column: {
                                    bodycell: ({ state }) => ({
                                        class: [{ 'pt-0 pb-0': state['d_editing'] }]
                                    })
                                }
                            }"
                            
                        >
                        <template #empty>
                            <div>데이터가 존재하지 않습니다.</div>
                        </template>
                            <Column
                                v-for="(inoutHist) in inoutHistGridColumn"
                                :key="inoutHist.field"
                                :field="inoutHist.field"
                                :header="inoutHist.header"
                                :style = "inoutHist.style"
                            >
                                <template #body="{data, field,index}">
                                    <div :style="getStyle(data, field, index)">
                                        <div v-if="field.includes('class_nm')" >
                                            <span class="elip-div2">{{ data[field]}}</span>
                                        </div>

                                        <div v-else-if="field == 'made_cmp_nm'">
                                            <span class="elip-div2">{{ getSummaryData(data[field])}}</span>
                                        </div>

                                        <div v-else-if="field == 'buy_cmp_nm'">
                                            <span class="elip-div2">{{ getSummaryData(data[field])}}</span>
                                        </div>

                                        <div v-else-if="field == 'gm_amt'">
                                            {{numberFomat(data[field]) }}
                                        </div>

                                        <div v-else-if="field == 'gm_amt_per'">
                                            {{data[field] }}
                                        </div> 

                                        <div v-else-if="field.includes('sum')">
                                            <span> {{ numberFomat(data[field])}} </span>
                                        </div>

                                        <div v-else-if="field == 'action'">
                                            <span :class="getActionOptionStyle(data.action)">{{ data.action }}</span>
                                        </div>

                                        <div v-else-if="field == 'memo' &&  data.memo !=''" :class="getOptionStyle('Y')" @click="clickOpenDialog({key:'view' , target: inoutHistDataList.searchedInoutHistList[data.index].memo,title :'매출세금 계산서 발행여부 취소사유'})">
                                            <div>{{ '보기'}}</div>
                                        </div>
                                        <div v-else-if="field == 'memo' && data.memo ==''" :class="getOptionStyle('N')">
                                            <div>{{ '없음' }}</div>
                                        </div>
                                        <div v-else-if="field ==='gpu_model_qty' && checkGPUModel(data['prod_class_id']) == true">
                                            <span> {{ numberFomat(data[field]) }} </span>
                                        </div>
                                        <div v-else-if="field ==='gpu_model_nm' && checkGPUModel(data['prod_class_id']) == true">
                                            <span> {{ getCodeNm(data[field]) }} </span>
                                        </div>
                                        <div v-else-if="field ==='gpu_model_nm' && 
                                            checkGPUModel(data['prod_class_id']) == false"
                                            style="text-align: center;"
                                        >
                                            <span> - </span>
                                        </div>
                                        <div v-else-if="field ==='gpu_model_qty' && 
                                            checkGPUModel(data['prod_class_id']) == false"
                                            style="text-align: center;"
                                        >
                                            <span> - </span>
                                        </div>

                                        <!--그 외 cell-->
                                        <span v-else class="elip-div2">  
                                         
                                        {{ data[field] }} </span>
                                    </div>
                                </template>
                            </Column>
                        </DataTable>
                    </div> 
                </div>
            </div>
        </div>
    </div>

    <ExcelManage
        v-show="false"
        ref="inoutExcelManageRef"
        @return="r => getExcelData(r.sheets)"
    />

    <DialogText ref="inoutHistDialogTextRef" modal dismissableMask="false"
    />

</template>

<script setup>
import common from "@/js/common";

import DatePicker from '@/components/common/DatePicker.vue';
import DialogText from '@/components/common/modal/DialogText.vue';
import ExcelManage from '@/components/common/MCO_EX_001.vue';
import DataTable from "primevue/datatable";

import { useLoading } from '@/composable/Loading.js'
import { salesOptySelect, salesOptyInoutHistList, salesOptyInoutList } from '@/api/sales';
import { getProdRevIdList, prodList,depthProdList } from '@/api/prod';
import { reactive,onBeforeMount,ref } from 'vue';
import Column from "primevue/column";
import { useCodeStore } from '@/store/code'

const props = defineProps({
  maxRev: {
    type: [String, Number],
    default: ''
  },
})


const codeStore = useCodeStore()

const { setIsLoading } = useLoading()

/*변수 Start*/
const inoutHistDialogTextRef = ref()
const inoutExcelManageRef = ref()

const rowsPerPage = ref(10); // 페이지당 데이터 수
const currentPage = ref(0); // 현재 페이지 번호

const state = reactive({
    startGroupName : 'A',
    maxRev : '',
    maxInoutSeq : '',
    groupName : '',
    optyInoutGroupList : [],
    gpu_model_prod_list:[],
})

const inoutHistDataList = reactive({
    // 원본 이력 데이터
    inoutHistRowData : [],
    // 원본 이력 데이터(inoutHistRowData) => 검색 조건 => 거쳐 나온 데이터
    searchedInoutHistList : [],
})

// 검색창 검색을 위해 사용하는 검색 조건
const inoutHistSearchParam = reactive({
    hist_dt_start :'',
    hist_dt_end:'',
    buy_cmp_nm :'',
    goods_nm:''
})
// api 통신을 위해 사용하는 조회 조건
const searchInoutHistParams = reactive({
    ims_seq : '',
    opty_seq : '',
    sales_id : '',
})

//매입매출 이력 조회 헤더
const inoutHistGridColumn = ref([
    { header: "매입매출 그룹", field: "group", style: { textAlign: "center", minWidth: "120px" }, sortable: true },
    { header: "이력 생성 동작", field: "action", style: { textAlign: "center", minWidth: "130px" }, sortable: true },
    { header: "이력 생성 일자", field: "hist_reg_dt", style: { textAlign: "center", minWidth: "140px" }, sortable: true },
    { header: "제조사", field: "made_cmp_nm", style: { textAlign: "left", minWidth: "120px" }, sortable: true },
    { header: "매입처", field: "buy_cmp_nm", style: { textAlign: "left", minWidth: "120px" }, sortable: true },
    { header: "상품1단계", field: 'class_nm1', style: { textAlign: "left", minWidth: '100px' }, sortable: true },
    { header: "상품2단계", field: 'class_nm2', style: { textAlign: "left", minWidth: '100px' }, sortable: true },
    { header: "상품3단계", field: 'class_nm3', style: { textAlign: "left", minWidth: '100px' }, sortable: true },
    { header: "GPU Model", field: 'gpu_model_nm', style: { minWidth: '100px' }, sortable: true, visible: false },
    { header: "GPU 수량", field: 'gpu_model_qty', style: { textAlign : 'right',minWidth: '120px' }, sortable: true, visible: false},
    { header: "매출금액(원)", field: "outcome_sum", style: { textAlign: "right", minWidth: "120px" }, sortable: true },
    { header: "매입금액(원)", field: "income_sum", style: { textAlign: "right", minWidth: "120px" }, sortable: true },
    { header: "Gross Margin(원)", field: "gm_amt", style: { textAlign: "right", minWidth: "160px" }, sortable: true },
    { header: "GM(%)", field: "gm_amt_per", style: { textAlign: "center", minWidth: "70px" }, sortable: true },
    { header: "매출 세금계산서 발행일", field: "tax_dt", style: { textAlign: "center", minWidth: "140px" }, sortable: true },
    { header: "발행 여부", field: "tax_yn", style: { textAlign: "center", minWidth: "70px" }, sortable: true },
    { header: "수금일", field: "collect_dt", style: { textAlign: "center", minWidth: "140px" }, sortable: true },
    { header: "수금 여부", field: "collect_yn", style: { textAlign: "center", minWidth: "70px" }, sortable: true },
    { header: "매입 세금계산서 발행일", field: "tax_sale_dt", style: { textAlign: "center", minWidth: "140px" }, sortable: true },
    { header: "매입 여부", field: "tax_sale_yn", style: { textAlign: "center", minWidth: "70px" }, sortable: true },
    { header: "지급일", field: "pay_dt", style: { textAlign: "center", minWidth: "140px" }, sortable: true },
    { header: "지급 여부", field: "pay_yn", style: { textAlign: "center", minWidth: "70px" }, sortable: true },
    { header: "취소 사유", field: "memo", style: { textAlign: "center", minWidth: "70px" }, sortable: true },
    
    { header: "수정자", field: "upd_user_nm", style: { textAlign: "center", minWidth: "90px" }, sortable: true }
])
/*변수 End*/

onBeforeMount(async()=>{
    // 임시에서는 매입매출 이력 출력 필요한가 2025-01-22
    let param = history.state;
    if(param.ims_seq){
        searchInoutHistParams.ims_seq = param.ims_seq
        searchInoutHistParams.opty_seq = null
        searchInoutHistParams.sales_id = null
    }else if(param.opty_seq){
        searchInoutHistParams.opty_seq = param.opty_seq
        searchInoutHistParams.sales_id = param.sales_id
        searchInoutHistParams.ims_seq = null
    }else{
        alert('잘못된 접근입니다.')
        router.go(-1)
    }
    await setInoutGroup()
    getGMandGMper();
    await searchInoutHistList();
    await getInoutHist()
    await getList2();
})

const getGlobalIndex = (localIndex) => {
  return currentPage.value * rowsPerPage.value + localIndex;
};

// 매입매출 inout 그룹 설정
const setInoutGroup = async() => {
    
    try{
        setIsLoading(true)
        let searchParams = {
            opty_seq:searchInoutHistParams.opty_seq,
            sales_id : searchInoutHistParams.sales_id
        }
        const res = await salesOptyInoutList(searchParams)
        const resList = [...res.rtn]
        let currentGroupName = 'A'; // 첫 그룹명 초기화

        // for...of 반복문으로 resList 순회
        for (const item of resList) {
            // opty_inout_seq로 기존 그룹 확인
            let existingGroup = state.optyInoutGroupList.find(
                (group) => group.seq === item.opty_inout_seq
            );

            // 그룹이 존재하지 않을 경우에만 새로 생성
            if (!existingGroup) {
                state.optyInoutGroupList.push({
                seq: item.opty_inout_seq,
                value: currentGroupName, // 현재 그룹명 사용
                });
                currentGroupName = getNextGroupName(currentGroupName); // 다음 그룹명 생성
            }
        }      

        // resList.forEach((item) => {
        //     state.optyInoutGroupList.push({ // push만 하도록 수정
        //         seq: item.opty_inout_seq,
        //         value: state.startGroupName, // 초기 빈 문자열로 설정
        //     });
        // });
    }catch(err) {
        console.error(err)
    } 
}
const checkGPUModel = (val)=>{

  return state.gpu_model_prod_list.some((r) =>{
    if(r.class_Id == val){
      return true
    }else{
      return false
    }
  })
}

//매입매출 이력 조회
const getInoutHist = async()=>{
    try{
        setIsLoading(true)
        //상품 조회 코드 추가하기
        state.maxRev = props.maxRev
        // const revRes = await getProdRevIdList()
        // revRes.rtn.forEach((item)=>{
        //     if(item.rev_id > state.maxRev) state.maxRev = item.rev_id
        // })

        const prodRes = await prodList({rev_id : state.maxRev})
        let prodResList = [...prodRes.rtn]

        let searchParams = {
            opty_seq:searchInoutHistParams.opty_seq
        }

        const res = await salesOptyInoutHistList(searchParams)
        let resList = [...res.rtn]
        inoutHistDataList.inoutHistRowData = resList.map((item,index)=>{
            item.index = index
            Object.keys(item).forEach((key)=>{
                if(key.includes('_dt')){
                    if(item[key] !== '19000101'){
                        item[key] = item[key] || 'N/A'
                    }else{
                        item[key] = 'N/A'
                    }
                }

                if(key.includes('_yn') && item[key] === 'A'){
                    item[key] = 'N/A'
                }
                if(key === 'action') {
                    if(item[key] == 'C'){
                        item[key] = '생성'
                    }else if(item[key] == 'U'){
                        item[key] = '수정'
                    }else if(item[key] == 'D'){
                        item[key] = '삭제'
                    }
                }else if(key == 'hist_reg_dt'){
                    item[key] = formatHistDate(item[key])
                //}
                }else if (key == 'opty_inout_seq') {
                    item['group'] = setInoutHistGroupName(item, key)
                }
            })
            let codeFam = common.findUperCode(item.prod_class_id,prodResList) || []
            item.prod_level = codeFam.length
            codeFam.forEach((codeItem,index)=>{
                item[`class_nm${index+1}`] = codeItem.class_nm
            })
            return item
        })
        // 그룹 정렬
        inoutHistDataList.inoutHistRowData.sort((a, b) => {
            if (a.group.length !== b.group.length) {
                return a.group.length - b.group.length;
             }
            return a.group.localeCompare(b.group, 'ko', { sensitivity: 'base' });
        });
    } catch(err) {
        console.error(err)
    } finally {
        setIsLoading(false)
    }
}


const getStyle=(data, field,index) =>{
    if(!data) return {};
    const globalIndex = getGlobalIndex(index); // 전체 인덱스 계산
    const prevData = inoutHistDataList.inoutHistRowData[globalIndex + 1];

    if ( field == 'hist_reg_dt' || field == 'action') return {};
    // 같은 그룹일 때만 비교
    if (prevData && prevData.group === data.group && prevData.opty_inout_seq === data.opty_inout_seq) {
        if (prevData[field] !== data[field]) {
            return { backgroundColor: "yellow", fontWeight: "bold" }; // 변경된 데이터 강조
        }
    }
    return {};
}


//매입매출정보 이력 조회
async function searchInoutHistList(){
    let rowData = [...inoutHistDataList.inoutHistRowData]

    rowData = inoutHistDataList.inoutHistRowData.filter((item) => {
        let flag = true;

        // 날짜 필터링을 위한 형식 변환
        const formattedDateStr = item.hist_reg_dt.replace(/(\d{4}-\d{2}-\d{2}).*/, '$1');
        const histRegDate = new Date(formattedDateStr);
        // 날짜 필터링 조건
        if (inoutHistSearchParam.hist_dt_start) {
            const startDate = new Date(inoutHistSearchParam.hist_dt_start);
            if (histRegDate < startDate) flag = false;
            if(!flag) return
        }

        if (inoutHistSearchParam.hist_dt_end) {
            const endDate = new Date(inoutHistSearchParam.hist_dt_end);
            if (histRegDate > endDate) flag = false;
            if(!flag) return
        }

        //매입처 이름 조건 filter
        if(inoutHistSearchParam.buy_cmp_nm){
            flag = item.buy_cmp_nm ? item.buy_cmp_nm.includes(inoutHistSearchParam.buy_cmp_nm) : false
            if(!flag) return
        }

        // 상품 조건 filter
        if(inoutHistSearchParam.goods_nm){
            if(item.prod_level){
                for(var i=1; i<=item.prod_level; i++){
                    let classNm = item[`class_nm${i}`].toLowerCase()
                    flag = classNm ? classNm.includes(inoutHistSearchParam.goods_nm.toLowerCase()) : false
                    if(flag) break;
                }
            }else{
                flag = false
            }
        }

        // 조건을 만족하면 item을 반환
        if(flag){
            return item
        }
    });

    inoutHistDataList.searchedInoutHistList = rowData || []
}

//매입매출 이력 목록 다운로드
const inoutHistExcelDown = ()=>{
    let fileNm = '매입매출 이력 목록'
    let inoutList = inoutHistDataList.inoutHistRowData;
    let header = [
        {header : '매입매출 그룹', key:'group'},
        {header : '이력 생성 일자', key:'hist_reg_dt'},
        {header : '제조사',key:'made_cmp_nm'},
        {header : '매입처',key:'buy_cmp_nm'},
        {header : '상품 1단계' ,  key : 'class_nm1'},
        {header : '상품 2단계' ,  key : 'class_nm2'},
        {header : '상품 3단계' ,  key : 'class_nm3'},
        {header : '매출금액(원)' ,key:'outcome_sum'},
        {header : '매입금액(원)' , key:'income_sum'},

        {header : 'Gross Margin' , key:'gm_amt'},
        {header : 'GM(%)' , key:'gm_amt_per'},
        {header : '매출세금계산서 발행일 (YYYY/MM/DD)',key:'tax_dt'},
        {header : '발행여부',key:'tax_yn' },
        {header : '수금일 (YYYY/MM/DD)' ,key:'collect_dt'},
        {header : '수금여부' ,key:'collect_yn'},

        {header : '매입세금계산서 발행일' ,key:'tax_sale_dt'},
        {header : '매입여부' ,key:'tax_sale_yn'},
        {header : '지급일' ,key:'pay_dt'},
        {header : '지급여부' ,key:'pay_yn'},
        {header : '취소사유' ,key:'memo'},
        {header : '이력 생성 동작' ,key:'action'},
        { header: "수정자", key: "upd_user_nm"}
    ];
    let headerProps = inoutHistGridColumn.value.map((item)=>{
        return item.field
    })
    inoutExcelManageRef.value.excelDownload(fileNm,header,inoutList,headerProps)
}

const clickOpenDialog = (value) =>{
    const {key,target,title} = value
    inoutHistDialogTextRef.value.openDialog(key,target,title)
}

const getList2 = async () => {
  let params = {
    rev_id: state.maxRev, // 리비전 ID 필수값
  };
  try {
    const res = await depthProdList(params)

    state.gpu_model_prod_list = res.rtn.filter(r=> r.gpu_model_yn ==='Y')
    return [...res.rtn]
  } catch (err) {
    console.error(err)
  } finally {

  }
};

const getNextGroupName = (groupName) => {
    const chars = groupName.split('');
    let carry = 1;

    for (let i = chars.length - 1; i >= 0; i--) {
        let charCode = chars[i].charCodeAt(0) + carry;
        carry = 0;

        if (charCode > 'Z'.charCodeAt(0)) {
            charCode = 'A'.charCodeAt(0);
            carry = 1;
        }

        chars[i] = String.fromCharCode(charCode);
    }

    if (carry === 1) {
        chars.unshift('A');
    }

    return chars.join('');
};


/*데이터 편집 메서드 Start*/
// 긴 문자열 값 자르기
const getSummaryData = (item) => {
    let summaryData = item.length > 13 ? item.slice(0, 13) + " ..." : item;
    return summaryData
}

// Gross Margin, GM% 값 새로 입력
const getGMandGMper = (list) => {
    let inoutHistRowDataList = inoutHistDataList.inoutHistRowData
    inoutHistRowDataList.map((item,index) =>{
        let a = Number(item.income_sum)
        let b = Number(item.outcome_sum)

        item['gm_amt'] = b - a
        const gm_amt_per = item['gm_amt'] / Number(item['outcome_sum']) * 100
        item['gm_amt_per']= `${Math.round(isFinite(Number(gm_amt_per)) ? Number(gm_amt_per): 0 )}%`
    })
    inoutHistDataList.inoutHistRowData = inoutHistRowDataList
}

// 숫자 포맷 맞추기
function numberFomat(number){
    if(number){
        return number = common.checkNumberComma(number)
    }
    return number
}

// 클래스 옵션 설정
const getOptionStyle = (item) => {
    const stageValue = item
    let classNm = ''
    if (stageValue == 'Y') {
        classNm = 'stage stage-close';
    } else if (stageValue == 'N') {
        classNm = 'stage stage-omit';
    }
    return classNm
}

const getActionOptionStyle = (item) => {
    const stageValue = item
    let classNm = ''
    if (stageValue == '생성') {
        classNm = 'stage stage-close';
    } else if (stageValue == '수정') {
        classNm = 'stage stage-won';
    } else if (stageValue == '삭제') {
        classNm = 'stage stage-pipeline';
    }
    return classNm
}

// 이력 생성 일자 시,분,초 붙이기
const formatHistDate = (item) => {
    const formattedDate = item.replace(
        /(\d{4}-\d{2}-\d{2}) (\d{2}):(\d{2}):(\d{2})/,
        (_, date, hour, minute, second) => `${date}  ${hour}시 ${minute}분 ${second}초`
    );
    return formattedDate
}

const setInoutHistGroupName = (item, key) => {
    const groupList = state.optyInoutGroupList;
    const matchedGroup = groupList.find((group) => group.seq == item[key]);

    if (matchedGroup) {
        return matchedGroup.value;
        
    } else {
        // 가장 마지막 그룹명 찾기 (길이와 알파벳 순서 고려)
        const lastGroup = groupList
            .map(group => group.value)
            .sort((a, b) => a.length - b.length || a.localeCompare(b))
            .pop() || 'A'; // 초기값 'A' 추가

        const nextGroupName = getNextGroupName(lastGroup); // 다음 그룹명 생성

        state.optyInoutGroupList.push({
            seq: item.opty_inout_seq,
            value: nextGroupName,
        });
        return nextGroupName;
    }
};
function getCodeNm(val){
  if(!val){
    return '-'
  }
  if(val){
    const getCodeNNm = codeStore.getCodeNm('GPU_MODEL_CD',val)
    return getCodeNNm.cd_nm
  } 
}

/*데이터 편집 메서드 End*/
</script>